import { oneDark, oneDarkEditor, oneLight, oneLightEditor } from '@/_shared/lib/syntax';

import { useIsDarkMode } from './useIsDarkMode';

/**
 * The active Prism theme for read-only code/SQL previews. Route every `SyntaxHighlighter`
 * through this instead of hardcoding `oneLight`, so previews flip in dark mode and a new
 * surface can't silently ship the light theme on a dark background.
 */
export function useSyntaxStyle(): typeof oneLight {
  return useIsDarkMode() ? oneDark : oneLight;
}

/** The active Prism theme for the live SQL editor overlay (neutralized metrics). */
export function useEditorSyntaxStyle(): typeof oneLightEditor {
  return useIsDarkMode() ? oneDarkEditor : oneLightEditor;
}
